<template>
  <div class="loading-container col px-0" :class="compact ? '' : 'loading-container-large'" aria-live="polite" :aria-busy="state === 'loading'">
    <div class="d-flex align-items-center flex-column w-100" :class="{ 'loading-small': small}">
      <h1 class="loading" v-if="state === 'loading' && !compact && !small" >{{ $t('common.loadingLong') }}</h1>
      <h2 class="loading" v-if="state === 'loading' && compact && !small" >{{ $t('common.loadingLong') }}</h2>
      <loader v-if="state === 'loading'" :i18nMessage="i18nLoadingMessage" :class="{ 'loader-small': small}" />
      <error-message v-if="state === 'error'" :i18nMessage="i18nErrorMessage" :error-uuid="errorUuid" class="mt-4" >
        <link-back v-if="state === 'error' && errorLinkTo" :to="errorLinkTo" :i18nMessage="i18nErrorLinkMessage" class="mt-2" />
        <button-action
            v-if="state === 'error' && showClearErrorRequestLink"
            i18n-message="common.understood"
            @click="$emit('clearErrorRequested')"
            class="mt-4"
            :btn-outline="true"
            :btn-css-color-class="buttonUnderStoodClass" />
      </error-message>
    </div>

    <slot v-if="state === 'success'"></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { LoadingState } from '@/utils/loadingUtils'
import Loader from '@/components/feedback/Loader.vue'
import ErrorMessage from '@/components/feedback/ErrorMessage.vue'
import LinkBack from '../interaction/LinkBack.vue';
import { RouteLocationRaw } from 'vue-router'
import ButtonAction from '../interaction/ButtonAction.vue';
import { CssColorClass } from '@/models/CssColorClass';

export default defineComponent({
  name: 'LoadingContainer',
  emits: (['clearErrorRequested']),
  props: {
    state: {
      type: String as PropType<LoadingState>,
      required: true

    },
    i18nErrorMessage: {
      type: String,
      default: 'common.error.unknown'
    },
    i18nErrorLinkMessage: {
      type: String,
      default: 'common.backToOverview'
    },
    i18nLoadingMessage: {
      type: String,
      default: undefined
    },
    errorLinkTo: {
      type: [String, Object] as PropType<RouteLocationRaw|string>,
      required: false
    },
    showClearErrorRequestLink: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * If the server sent an Error-UUID show it. It might be useful for finding the cause of the error.
     */
    errorUuid: {
      type: String,
      default: undefined,
      required: false
    },
    /**
     * If compact=true the Loading has no min-height
     */
    compact: {
      type: Boolean,
      required: false,
      default: false
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    Loader,
    ErrorMessage,
    LinkBack,
    ButtonAction
  },
  data() {
    return {
      buttonUnderStoodClass: CssColorClass.danger,
    }
  }
});
</script>
<style scoped>
  .loading-container[aria-busy=true] {
    height: auto;
  }
  .loading-container-large[aria-busy=true] {
    min-height: 200px;
  }

  .loading {
    font-size: 27px;
    font-size: 1.6875rem;
    font-weight: 500;
  }

  .loading-small .loading {
    font-size: 1rem;
  }
  .loading-small .loader-small {
    width: 40px;
    height: 40px;
  }
</style>
